"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentSearchList = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const common_1 = require("@/components/common");
const list_item_styles_1 = require("@/components/common/list-item/list-item.styles");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/common");
/**
 * 최근 검색어 목록. 검색어를 누르면 그 검색어로 다시 검색하도록 알리고, 삭제 버튼은 항목을 목록에서 스스로 지운 뒤 알린다.
 * 검색어와 삭제 버튼이 저마다 Tab 순서를 갖도록 menu가 아닌 list로 읽히고, 두 버튼은 중첩하지 않고 형제로 둔다.
 * heading은 목록 밖에 제목 요소로 렌더하고 목록에 aria-labelledby로 연결한다.
 */
let RecentSearchList = class RecentSearchList extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.keywords = [];
        this.headingId = (0, utils_1.uniqueId)('recent-search-heading');
    }
    render() {
        return (0, lit_1.html) `
      ${this.renderHeading()}
      <mm-list-item-group
        gap="0"
        aria-labelledby=${(0, if_defined_js_1.ifDefined)(this.heading ? this.headingId : undefined)}
      >
        ${this.keywords.map(keyword => this.renderKeyword(keyword))}
      </mm-list-item-group>
    `;
    }
    renderHeading() {
        if (!this.heading)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-heading level="5" id=${this.headingId}>${this.heading}</mm-heading>
    `;
    }
    renderKeyword(keyword) {
        return (0, lit_1.html) `
      <div class="item">
        <button type="button" @click=${() => this.handleKeywordClick(keyword)}>
          <mm-list-item label=${keyword}></mm-list-item>
        </button>
        <mm-icon-button
          size="small"
          icon=${common_1.ICON_NAMES.DISMISS}
          aria-label="'${keyword}' 검색 기록 삭제"
          @click=${() => this.handleRemoveClick(keyword)}
        ></mm-icon-button>
      </div>
    `;
    }
    handleKeywordClick(keyword) {
        (0, utils_1.emit)(this, 'recent-search-select', { value: keyword });
    }
    handleRemoveClick(keyword) {
        this.keywords = this.keywords.filter(item => item !== keyword);
        (0, utils_1.emit)(this, 'recent-search-remove', { value: keyword });
    }
};
RecentSearchList.styles = [
    shared_styles_1.resetStyles,
    list_item_styles_1.interactiveRowStyles,
    (0, lit_1.css) `
      :host {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
      }

      .item {
        display: flex;
        align-items: center;
        gap: var(--space-2);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], RecentSearchList.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], RecentSearchList.prototype, "keywords", void 0);
RecentSearchList = __decorate([
    (0, decorators_js_1.customElement)('mm-recent-search-list')
], RecentSearchList);
exports.RecentSearchList = RecentSearchList;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVjZW50LXNlYXJjaC1saXN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicmVjZW50LXNlYXJjaC1saXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFvRDtBQUNwRCxxREFBMkQ7QUFDM0QsZ0VBQXdEO0FBRXhELGdEQUFnRDtBQUNoRCxxRkFBcUY7QUFDckYsK0RBQXlEO0FBQ3pELG1DQUF3QztBQUN4QywrQkFBNEI7QUFFNUI7Ozs7R0FJRztBQUVJLElBQU0sZ0JBQWdCLEdBQXRCLE1BQU0sZ0JBQWlCLFNBQVEsZ0JBQVU7SUFBekM7O1FBbUIyQixhQUFRLEdBQWEsRUFBRSxDQUFBO1FBQ3RDLGNBQVMsR0FBRyxJQUFBLGdCQUFRLEVBQUMsdUJBQXVCLENBQUMsQ0FBQTtJQThDaEUsQ0FBQztJQTVDQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTtRQUNQLElBQUksQ0FBQyxhQUFhLEVBQUU7OzswQkFHRixJQUFBLHlCQUFTLEVBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDOztVQUVwRSxJQUFJLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsT0FBTyxDQUFDLENBQUM7O0tBRTlELENBQUE7SUFDSCxDQUFDO0lBRU8sYUFBYTtRQUNuQixJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU87WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUVqQyxPQUFPLElBQUEsVUFBSSxFQUFBO2lDQUNrQixJQUFJLENBQUMsU0FBUyxJQUFJLElBQUksQ0FBQyxPQUFPO0tBQzFELENBQUE7SUFDSCxDQUFDO0lBRU8sYUFBYSxDQUFDLE9BQWU7UUFDbkMsT0FBTyxJQUFBLFVBQUksRUFBQTs7dUNBRXdCLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQyxrQkFBa0IsQ0FBQyxPQUFPLENBQUM7Z0NBQzdDLE9BQU87Ozs7aUJBSXRCLG1CQUFVLENBQUMsT0FBTzt5QkFDVixPQUFPO21CQUNiLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxPQUFPLENBQUM7OztLQUduRCxDQUFBO0lBQ0gsQ0FBQztJQUVPLGtCQUFrQixDQUFDLE9BQWU7UUFDeEMsSUFBQSxZQUFJLEVBQUMsSUFBSSxFQUFFLHNCQUFzQixFQUFFLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRSxDQUFDLENBQUE7SUFDeEQsQ0FBQztJQUVPLGlCQUFpQixDQUFDLE9BQWU7UUFDdkMsSUFBSSxDQUFDLFFBQVEsR0FBRyxJQUFJLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLElBQUksS0FBSyxPQUFPLENBQUMsQ0FBQTtRQUM5RCxJQUFBLFlBQUksRUFBQyxJQUFJLEVBQUUsc0JBQXNCLEVBQUUsRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFLENBQUMsQ0FBQTtJQUN4RCxDQUFDOztBQWhFTSx1QkFBTSxHQUFHO0lBQ2QsMkJBQVc7SUFDWCx1Q0FBb0I7SUFDcEIsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7OztLQVlGO0NBQ0YsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7aURBQWlCO0FBQ1o7SUFBL0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxDQUFDO2tEQUF3QjtBQW5CNUMsZ0JBQWdCO0lBRDVCLElBQUEsNkJBQWEsRUFBQyx1QkFBdUIsQ0FBQztHQUMxQixnQkFBZ0IsQ0FrRTVCO0FBbEVZLDRDQUFnQiJ9